// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let Scalars = require("../../scalars/Scalars.bs.js");
let TanDate = require("../../reason/common/types/TanDate.bs.js");
let UTCDate = require("../../reason/common/types/UTCDate.bs.js");
let DateFns = require("date-fns");
let DateFnsTz = require("../../reason/common/DateFns/DateFnsTz.bs.js");
let CalendarDate = require("../../reason/common/types/CalendarDate.bs.js");
let Stdlib_Array = require("@rescript/runtime/lib/js/Stdlib_Array.js");
let Stdlib_Option = require("@rescript/runtime/lib/js/Stdlib_Option.js");
let ListingDetails = require("../common/Components/ListingDetails.bs.js");
let Stdlib_Ordering = require("@rescript/runtime/lib/js/Stdlib_Ordering.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let PropertyParkingInfo = require("../common/Property/PropertyParkingInfo.bs.js");
let FragmentErrorBoundary = require("../common/Components/FragmentErrorBoundary.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let PropertyPageForSalePropertyListingDetails_property_graphql = require("../../__generated__/PropertyPageForSalePropertyListingDetails_property_graphql.bs.js");

let convertFragment = PropertyPageForSalePropertyListingDetails_property_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyPageForSalePropertyListingDetails_property_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyPageForSalePropertyListingDetails_property_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, PropertyPageForSalePropertyListingDetails_property_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyPageForSalePropertyListingDetails_property_graphql.node, convertFragment, fRef);
}

let Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function yesOrNo(value) {
  if (value) {
    return "Yes";
  } else {
    return "No";
  }
}

function PropertyPage__ForSalePropertyListingDetails$WithoutErrorBoundary(props) {
  let property = RescriptRelay_Fragment.useFragment(PropertyPageForSalePropertyListingDetails_property_graphql.node, convertFragment, props.property);
  let timeOnTan = DateFns.formatDistance(UTCDate.toUnzonedDate(Scalars.DateTime.toUTC(property.onTanAt)), new Date());
  let hasBeenUpdated = UTCDate.toUnzonedDate(Scalars.DateTime.toUTC(property.updatedAt)).getTime() === UTCDate.toUnzonedDate(Scalars.DateTime.toUTC(property.onTanAt)).getTime();
  let lastUpdated = hasBeenUpdated ? UTCDate.toUnzonedDate(Scalars.DateTime.toUTC(property.updatedAt)) : undefined;
  let match = property.mlsPlan;
  let match$1;
  switch (match.__typename) {
    case "ListOnMlsAsActive" :
      match$1 = [
        DateFns.format(CalendarDate.toLocalDate(match.onMlsAt), "MMM d, YYY"),
        match.willShowPriorToMls ? "Yes" : "No",
        match.willAcceptOffersPriorToMls ? "Yes" : "No"
      ];
      break;
    case "ListOnMlsAsComingSoon" :
      match$1 = [
        DateFns.format(CalendarDate.toLocalDate(match.activeOnMlsOn), "MMM d, YYY"),
        match.willShowPriorToMls ? "Yes" : "No",
        match.willAcceptOffersPriorToMls ? "Yes" : "No"
      ];
      break;
    case "__unselected" :
      match$1 = [
        undefined,
        undefined,
        undefined
      ];
      break;
  }
  let match$2 = property.chapter;
  let tmp;
  if (match$2 !== undefined) {
    let timezone = match$2.timezone;
    let arr = Stdlib_Array.filterMap(property.showings.edges, v => Stdlib_Option.flatMap(v, x => x.node)).filter(showing => DateFns.isAfter(UTCDate.toUnzonedDate(Scalars.DateTime.toUTC(showing.startDate)), TanDate.now())).slice();
    tmp = Stdlib_Option.getOr(Stdlib_Option.map((arr.sort((a, b) => Stdlib_Ordering.fromInt(UTCDate.toUnzonedDate(Scalars.DateTime.toUTC(a.startDate)).getTime() - UTCDate.toUnzonedDate(Scalars.DateTime.toUTC(b.startDate)).getTime() | 0)), arr)[0], showing => DateFns.format(UTCDate.toZonedDate(Scalars.DateTime.toUTC(showing.startDate), DateFnsTz.Timezone.make(timezone)), "MMM d 'at' h:mm a")), "None scheduled");
  } else {
    tmp = undefined;
  }
  let nextShowing = Stdlib_Option.map(tmp, prim => prim);
  let commission = Stdlib_Option.map(property.commission, prim => prim);
  let match$3 = property.propertyType;
  let match$4;
  match$4 = match$3.__typename === "CondoProperty" ? [
      match$3.parkingSpaces,
      match$3.parkingDetails
    ] : [
      undefined,
      undefined
    ];
  let parkingValues = PropertyParkingInfo.ListingDetails.make(true, match$4[0], match$4[1]);
  let website = Stdlib_Option.map(Stdlib_Option.map(property.website, Scalars.URL.toString), website => JsxRuntime.jsx("a", {
    children: website,
    href: website,
    target: "_blank"
  }));
  return JsxRuntime.jsx(ListingDetails.make, {
    timeOnTan: timeOnTan,
    commission: commission,
    parkingSpots: parkingValues.parkingSpots,
    parkingDetails: parkingValues.parkingDetails,
    website: website,
    lastUpdated: lastUpdated,
    nextShowing: nextShowing,
    expectedOnMls: Stdlib_Option.map(match$1[0], prim => prim),
    willShowBeforeMls: Stdlib_Option.map(match$1[1], prim => prim),
    willAcceptOffersBeforeMls: Stdlib_Option.map(match$1[2], prim => prim),
    titleClassName: props.titleClassName
  });
}

let WithoutErrorBoundary = {
  make: PropertyPage__ForSalePropertyListingDetails$WithoutErrorBoundary
};

function PropertyPage__ForSalePropertyListingDetails(props) {
  return JsxRuntime.jsx(FragmentErrorBoundary.make, {
    fragmentDisplayName: "listing details",
    children: JsxRuntime.jsx(PropertyPage__ForSalePropertyListingDetails$WithoutErrorBoundary, {
      property: props.property,
      titleClassName: props.titleClassName
    })
  });
}

let make = PropertyPage__ForSalePropertyListingDetails;

exports.Fragment = Fragment;
exports.yesOrNo = yesOrNo;
exports.WithoutErrorBoundary = WithoutErrorBoundary;
exports.make = make;
/* Scalars Not a pure module */
